import React from 'react';
import Hero from './components/about-us/chaudhary-charan-singh/Hero';
import Main from './components/about-us/chaudhary-charan-singh/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const ChaudharyCharanSingh = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default ChaudharyCharanSingh;